
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/spelers/[slug]",
      function () {
        return require("private-next-pages/spelers/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/spelers/[slug]"])
      });
    }
  